module.exports = __webpack_public_path__ + "static/media/triticum_aestivum.whole_plant.eb959d9b.svg";